import request from '@/utils/request'

/**
 * @param {Object} data
 */

// 等级列表
export function user_level_list_api() {
    return request({
        url: '/user/level_list',
        method: 'get'
    })
}
// 代理团队列表
export function user_team_list_api() {
    return request({
        url: '/user/team_lis',
        method: 'post'
    })
}

// 退出
export function user_login_out_api() {
    return request({
        url: '/user/loginOut',
        method: 'post'
    })
}

// 代理团队列表
export function user_team_lis_api(data) {
    return request({
        url: '/user/team_lis',
        method: 'post',
		data
    })
}

// 商品浏览记录
export function user_goods_history_api(data) {
    return request({
        url: '/user/goods_history',
        method: 'post',
		data
    })
}
// 分红计划列
export function user_bonus_index_api(data) {
    return request({
        url: '/bonus/index',
        method: 'post',
		data
    })
}

// 收藏列表
export function user_favorites_list_api(data) {
    return request({
        url: '/user/favorites_list',
        method: 'get',
		data
    })
}
// 删除收藏
export function user_del_favorites_api(data) {
    return request({
        url: '/user/del_favorites',
        method: 'post',
		data
    })
}



// 手机号验证码发送
export function send_phone_code_api(data) {
    return request({
        url: '/api/send_phone_code',
        method: 'post',
        data
    })
}
// 邮箱验证码发送
export function send_email_code_api(data) {
    return request({
        url: '/api/send_email_code',
        method: 'post',
        data
    })
}
// 验证手机号或邮箱
export function check_mobile_email_api(data) {
    return request({
        url: '/user/check_mobile_email',
        method: 'post',
        data
    })
}
// 设置/修改支付密码
export function set_pay_pwd_api(data) {
    return request({
        url: '/user/set_pay_pwd',
        method: 'post',
        data
    })
}
// 用户银行卡列表
export function bank_list_api(data) {
    return request({
        url: '/user/bank_list',
        method: 'post',
        data
    })
}
// 添加银行卡
export function add_bank_api(data) {
    return request({
        url: '/user/add_bank',
        method: 'post',
        data
    })
}
// 删除银行卡
export function bank_del_api(data) {
    return request({
        url: '/user/bank_del',
        method: 'post',
        data
    })
}
// 修改登录密码
export function change_pwd_api(data) {
    return request({
        url: '/user/change_pwd',
        method: 'post',
        data
    })
}



// 收货地址列表
export function address_api(data) {
    return request({
        url: '/address/index',
        method: 'get',
        data
    })
}

// 收货地址详情
export function address_detail_api(data) {
    return request({
        url: '/address/detail',
        method: 'post',
        data
    })
}

// 添加/编辑收货地址
export function address_save_api(data) {
    return request({
        url: '/address/save',
        method: 'post',
        data
    })
}

///删除收货地址
export function address_delete_api(data) {
    return request({
        url: '/address/delete',
        method: 'post',
        data
    })
}

//修改用户信息
export function user_save_api(data) {
    return request({
        url: '/user/save',
        method: 'post',
        data
    })
}

//上传图片
export function user_upload_api(data) {
    return request({
        url: '/upload/upload',
        method: 'post',
        data
    })
}

//加入购物车
export function goods_addCart_api(data) {
    return request({
        url: '/goods/addCart',
        method: 'post',
        data
    })
}
//购物车列表
export function goods_cartList_api(data) {
    return request({
        url: '/goods/cartList',
        method: 'post',
        data
    })
}
//删除购物车
export function goods_delCart_api(data) {
    return request({
        url: '/goods/delCart',
        method: 'post',
        data
    })
}
// 下单
export function order_add_api(data) {
    return request({
        url: '/order/add',
        method: 'post',
        data
    })
}
// 取消订单
export function order_cancel_api(data) {
    return request({
        url: '/order/cancel',
        method: 'post',
        data
    })
}

// 订单列表
export function order_list_api(data) {
    return request({
        url: '/order/index',
        method: 'post',
        data
    })
}

// 订单付款
export function order_pay_api(data) {
    return request({
        url: '/order/pay',
        method: 'post',
        data
    })
}

// 支付渠道
export function payment_lists_api(data) {
    return request({
        url: '/payment/lists',
        method: 'post',
        data
    })
}

// 订单详情
export function order_detail_api(data) {
    return request({
        url: '/order/detail',
        method: 'post',
        data
    })
}

// 充值
export function payment_pay_api(data) {
    return request({
        url: '/payment/pay',
        method: 'post',
        data
    })
}

// 提现
export function payment_withdraw_api(data) {
    return request({
        url: '/payment/withdraw',
        method: 'post',
        data
    })
}
// 评价
export function order_comment_api(data) {
    return request({
        url: '/order/comment',
        method: 'post',
        data
    })
}
// 确认收货
export function order_confirm_api(data) {
    return request({
        url: '/order/confirm',
        method: 'post',
        data
    })
}
// 账户余额明细
export function user_money_log_api(data) {
    return request({
        url: '/user/money_log',
        method: 'post',
        data
    })
}

// 兑换优惠劵
export function coupons_exchange_api(data) {
    return request({
        url: '/coupons/exchange',
        method: 'post',
        data
    })
}
// 我的优惠劵列表
export function coupons_index_api(data) {
    return request({
        url: '/coupons/index',
        method: 'post',
        data
    })
}

// 获取可用优惠券
export function get_coupon_api(data) {
    return request({
        url: '/coupons/get_coupon',
        method: 'post',
        data
    })
}

// 下级返佣记录
export function tree_money_log_api(data) {
    return request({
        url: '/user/tree_money_log',
        method: 'post',
        data
    })
}















